module.exports = __webpack_public_path__ + "img/loginhome_banner.b1ced08b.png";